export default "__VITE_ASSET__Bt11VMQG__"